// toast.ts

export function showToast(message: string, type: 'success' | 'error') {
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;

    if (type === 'success') {
        toast.classList.add('toast-success');
    } else if (type === 'error') {
        toast.classList.add('toast-error');
    }

    document.body.appendChild(toast);
    toast.style.display = 'block';
    setTimeout(() => {
        toast.style.opacity = '0';
        setTimeout(() => {
            toast.remove(); // Remove after fading out
        }, 300);
    }, 3000);
}
